import { handleActions } from 'redux-actions';
import {
  employeeBadgeSuccess,
  employeeClientEmailSettingsSuccess,
  employeeMobilePatrolEmailSettingsSuccess,
  employeeSiteEmailSettingsSuccess,
  employeesSuccess,
  getUserSuccess,
  updateEmployeeBadgeSuccess,
  updateEmployeeClientEmailSettingsSuccess,
  updateEmployeeMobilePatrolEmailSettingsSuccess,
  updateEmployeeSiteEmailSettingsSuccess,
} from './actions';
import { logoutSuccess } from 'ducks/auth/actions';

import initialState from './states';

export default handleActions(
  {
    [employeesSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [getUserSuccess](state, { payload }) {
      return {
        ...state,
        users: {
          ...state.users,
          [payload.userID]: payload,
        },
      };
    },
    [employeeBadgeSuccess](state, { payload }) {
      return {
        ...state,
        badges: {
          ...state.badges,
          [payload.employeeID]: payload,
        },
      };
    },
    [updateEmployeeBadgeSuccess](state, { payload: { employeeID, payload } }) {
      return {
        ...state,
        badges: {
          ...state.badges,
          [employeeID]: {
            ...state.badges[employeeID],
            ...payload,
          },
        },
      };
    },
    [employeeClientEmailSettingsSuccess](state, { payload: { employeeID, payload } }) {
      return {
        ...state,
        clientEmailSettings: {
          ...state.clientEmailSettings,
          [employeeID]: payload,
        },
      };
    },
    [employeeSiteEmailSettingsSuccess](state, { payload: { employeeID, payload } }) {
      return {
        ...state,
        siteEmailSettings: {
          ...state.siteEmailSettings,
          [employeeID]: payload,
        },
      };
    },
    [employeeMobilePatrolEmailSettingsSuccess](state, { payload: { employeeID, payload } }) {
      return {
        ...state,
        mobilePatrolEmailSettings: {
          ...state.mobilePatrolEmailSettings,
          [employeeID]: payload,
        },
      };
    },
    [updateEmployeeClientEmailSettingsSuccess](state, { payload: { employeeID, payload } }) {
      return {
        ...state,
        clientEmailSettings: {
          ...state.clientEmailSettings,
          [employeeID]: payload,
        },
      };
    },
    [updateEmployeeSiteEmailSettingsSuccess](state, { payload: { employeeID, payload } }) {
      return {
        ...state,
        siteEmailSettings: {
          ...state.siteEmailSettings,
          [employeeID]: payload,
        },
      };
    },
    [updateEmployeeMobilePatrolEmailSettingsSuccess](state, { payload: { employeeID, payload } }) {
      return {
        ...state,
        mobilePatrolEmailSettings: {
          ...state.mobilePatrolEmailSettings,
          [employeeID]: payload,
        },
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
